/** True when logo is a remote/storage URL (from gamesHome.logo). */
export function isRemoteLogoUrl(logo?: string | null): boolean {
  if (!logo) return false;
  return /^https?:\/\//i.test(logo) || logo.startsWith('data:') || logo.startsWith('blob:');
}

/**
 * Resolves a gamesHome.logo value to an img src.
 * - Remote URL → use as-is
 * - Absolute/asset path → use as-is
 * - Slug (legacy) → `/assets/frames/{slug}.svg`
 */
export function resolveGameLogoSrc(logo?: string | null, fallback?: string): string {
  if (!logo) return fallback || '';
  if (isRemoteLogoUrl(logo)) return logo;
  if (logo.startsWith('/') || logo.startsWith('assets/') || logo.startsWith('./') || logo.startsWith('../')) {
    return logo;
  }
  return `/assets/frames/${logo}.svg`;
}

export function normalizeLogoKey(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_-]+/g, '');
}
